import { EntityAdapter, EntityState, createEntityAdapter } from '@ngrx/entity';
import { createReducer, on } from '@ngrx/store';

import { ReduceToClearRequestAction, ReduceToClearRequestViewAction } from './reduce-to-clear-request.actions';
import {
  ReduceToClearRequestListContent,
  ReduceToClearRequestSearchCriteria,
  reduceToClearRequestStatusList
} from '../../model/reduce-to-clear-request.model';

export interface ReduceToClearRequestState extends EntityState<ReduceToClearRequestListContent> {
  isLoading: boolean;
  selected: any[];
  criteriaObject: ReduceToClearRequestSearchCriteria;
  totalElements: number;
  totalPages: number;
  auditLogs: any;
  viewReduceToClearRequest: any;
}

export const adapter: EntityAdapter<ReduceToClearRequestListContent> =
  createEntityAdapter<ReduceToClearRequestListContent>({
    selectId: (model: ReduceToClearRequestListContent) => model.requestNo
  });

export const initialReduceToClearRequestState: ReduceToClearRequestState = adapter.getInitialState({
  isLoading: false,
  criteriaObject: {
    page: 0,
    size: 20,
    status: reduceToClearRequestStatusList[0].value
  },
  selected: [],
  totalElements: null,
  totalPages: 20,
  auditLogs: [],
  viewReduceToClearRequest: null
});

export const reduceToClearRequestReducer = createReducer(
  initialReduceToClearRequestState,
  on(ReduceToClearRequestAction.responseList, (state, action): ReduceToClearRequestState => {
    return {
      ...state,
      selected: action.data.content,
      totalElements: action.data.totalElements,
      isLoading: false,
      criteriaObject: {
        ...state.criteriaObject,
        page: action.data.page,
        size: action.data.size
      }
    };
  }),
  on(ReduceToClearRequestViewAction.response, (state, action): ReduceToClearRequestState => {
    return {
      ...state,
      viewReduceToClearRequest: action.data
    };
  }),
  on(ReduceToClearRequestViewAction.resetView, (state): ReduceToClearRequestState => {
    return {
      ...state,
      viewReduceToClearRequest: null
    };
  })
);
